// Screen: "Euchre Game Table"
import React from 'react';
import Euchre from '../Euchre';

export default function EuchrePage() {
  return <Euchre />;
}
